import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Gift, ChevronRight, X } from "lucide-react";
import api from "../lib/api";
import { fmt0 } from "../lib/format";

/* New customer with bonus money but no booking yet: "₹25 bonus இருக்கு — ஒரு ticket போடுங்க". Hides itself after the first booking. */
export const FirstPlayStrip = ({ token }) => {
  const [n, setN] = useState(null);
  const [hide, setHide] = useState(sessionStorage.getItem("rl_first_play_hide") === "1");
  const nav = useNavigate();
  useEffect(() => { if (!token) return; api.get("/nudges/first-play").then((r) => setN(r.data)).catch(() => {}); }, [token]);
  if (!token || hide || !n?.show) return null;
  return (
    <div className="mx-4 mt-3 rounded-2xl p-3 flex items-center gap-3 bg-gradient-to-r from-emerald-600 to-emerald-500 text-white shadow-lg rl-fade-up" data-testid="first-play-strip">
      <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center shrink-0 animate-pulse"><Gift className="w-5 h-5" /></div>
      <button onClick={() => nav(n.game_id ? `/play/${n.game_id}` : "/")} className="flex-1 text-left min-w-0" data-testid="first-play-cta">
        <div className="font-black text-sm leading-tight"><span data-testid="first-play-amount">{fmt0(n.amount)}</span> bonus இருக்கு — ஒரு ticket போடுங்க!</div>
        <div className="text-[11px] text-white/85 truncate">Recharge தேவையில்லை · இலவசமா முதல் ஆட்டம்{n.game_name ? ` · ${n.game_name}` : ""} <ChevronRight className="w-3 h-3 inline" /></div>
      </button>
      <button onClick={() => { sessionStorage.setItem("rl_first_play_hide", "1"); setHide(true); }} className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center shrink-0" aria-label="Close" data-testid="first-play-close"><X className="w-3.5 h-3.5" /></button>
    </div>
  );
};
